<template>
	<home-tile
		class="multiplier-tile"
		color="cerulean"
		button-title="Set Multiplier"
		:loading="isLoading"
		@click="handleSetMultiplier"
	>
		<span class="tile-text-small">
			Multiply your impact!<br />You are donating {{ user.multiplier }}x
			your change.
		</span>
		<div class="multiplier-options">
			<segment-toggle
				:value="multiplier"
				:options="options"
				name="multiplier"
				@on-change="updateMultiplier"
				labelSuffix="x"
			/>
		</div>
	</home-tile>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import HomeTile from './HomeTile'
import SegmentToggle from '../../ui/SegmentToggle'

export default {
	name: 'multiplier-tile',
	components: { HomeTile, SegmentToggle },
	data() {
		return {
			options: [1, 2, 3, 10],
			multiplier: 1,
			isLoading: false
		}
	},
	computed: {
		...mapGetters(['user'])
	},
	methods: {
		...mapActions(['setMultiplier']),
		updateMultiplier(val) {
			this.multiplier = val
		},
		handleSetMultiplier() {
			this.isLoading = true
			this.setMultiplier(this.multiplier)
				.then(() => {
					this.isLoading = false
					this.$swal(
						'Success',
						'Your multiplier has been set! Your next donation will increase by this multiplier!'
					)
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal('Error', message)
				})
		}
	},
	mounted() {
		this.multiplier = this.user.multiplier
	}
}
</script>

<style lang="scss">
.multiplier-tile {
	.segmented-control {
		background: $navy;
		display: flex;
		width: 100%;
		margin-top: 20px;
		margin-bottom: 0px;
		padding: 0;
		border-radius: 25px;
		.segmented-control__item {
			flex-grow: 1;
			flex-basis: 0;
			margin: 0;
			padding: 0;
			list-style-type: none;
		}
		.segmented-control__input {
			position: absolute;
			visibility: hidden;
			&:checked {
				& + .segmented-control__label {
					background: $white;
					color: $navy-highlight;
				}
			}
		}
		.segmented-control__label {
			display: block;
			padding: 15px 10px;
			text-align: center;
			cursor: pointer;
			border-radius: 25px;
			font-weight: bold;
			&:hover {
				background: $navy-highlight;
				color: $white;
			}
		}
	}
}
</style>
